import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SkeletonTableComponent } from './skeleton-table.component';

@Component({
  selector: 'app-mobile-space-skeleton-animation',
  standalone: true,
  imports: [NgxSkeletonLoaderModule, SkeletonTableComponent],
  templateUrl: './space-skeleton-animation.component.html',
})
export class SpaceSkeletonAnimationComponent {}
